
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 96.35 96.35"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('g',{attrs:{"data-name":"Layer 1"}},[_c('path',{attrs:{"d":"M14.11 14.1a48.18 48.18 0 1 0 68.13 68.14 48.18 48.18 0 0 0 0-68.13 48.18 48.18 0 0 0-68.13 0z","fill":"#35bdd1"}}),_c('path',{attrs:{"d":"M76.07 57.58a2.54 2.54 0 0 1-4.33 1.79L48.18 35.81 24.62 59.37A2.53 2.53 0 1 1 21 55.79l25.39-25.36a2.54 2.54 0 0 1 3.59 0l25.35 25.36a2.5 2.5 0 0 1 .74 1.79z","fill":"#fff"}})])])])
          )
        }
      }
    